export const emailErrorMessage = "Invalid Email";
export const requiredMessage = "This field is required";
export const phoneMessage = "Invalid phone number";

export const maxDateMessage = "Date cannot be greater than today.";
export const endDateMesssage = "End date cannot be less than start date.";
